/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Print_ExportInputs */

const zh_print_export = /** @type {(inputs: Print_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出`)
};

const en_print_export = /** @type {(inputs: Print_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export`)
};

const es_print_export = /** @type {(inputs: Print_ExportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar`)
};

/**
* | output |
* | --- |
* | "Export" |
*
* @param {Print_ExportInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const print_export = /** @type {((inputs?: Print_ExportInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Print_ExportInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_print_export(inputs)
	if (locale === "en") return en_print_export(inputs)
	return es_print_export(inputs)
});